import React from 'react';
import 'whatwg-fetch';
import swal from 'sweetalert2';
import {observer} from 'mobx-react';
import Mousetrap from 'mousetrap';
import {Modal, ModalBody} from 'reactstrap';
import addModal from '../utils/state/react_modals';
import addContext from '../utils/state/context';
import trackProgress from '../utils/state/progress';
import fbq from '../utils/facebook_pixel';
import './add_to_cart.css';

@observer
export default class CartUpdatedDialog extends React.Component {
  componentDidMount() {
    const mt = Mousetrap();

    this.context = addContext({
      register: () => {
      },
      unregister: () => {
        mt.reset();
      }
    });
  }

  componentWillUnmount() {
    this.context.remove();
  }

  render() {
    return (
      <div>
        <Modal isOpen={true} toggle={this.props.onClose}>
          <ModalBody>
            <div className="cart-add-dialog">
              <div dangerouslySetInnerHTML={{__html: this.props.contents}} className="cart-contents"/>
              <div className="d-flex">
                <button type="button" onClick={this.props.onClose}>
                  Continue Shopping
                </button>
                &nbsp;&nbsp;
                <a href="/store/cart/" onClick={this.props.onClose}>
                  View Cart
                </a>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function addToCart(form) {
  fbq('track', 'AddToCart');

  trackProgress({
    name: 'Adding to cart...',
    modal: false,
    promise: window.fetch('/store/add-to-cart/', {
      method: 'post',
      body: new FormData(form),
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
    }).then(response => {
      if (response.ok) {
        response.json().then(data => {
          addModal((close, confirm) => (
            <CartUpdatedDialog onClose={close} onSelect={confirm} contents={data.contents}/>
          ));
        });
      } else {
        window.experimentalCart = false;
        form.submit();
      }
    }, () => {
      window.experimentalCart = false;
      form.submit();
    })
  });
}

document.body.addEventListener('submit', event => {
  const form = event.target;

  if (form.getAttribute("action").match(/cart\.cgi|store\/add-to-cart\/|store\/addtocart\.aspx/i)) {
    if (form.getAttribute('data-cart-add-type') === 'multireg') {
      const discountLevelsString = form.getAttribute('data-workshop-combo-discount') || "50,70";
      const discountLevels = [];
      for (const entry of discountLevelsString.split(/,/)) {
        discountLevels.push(parseFloat(entry));
      }

      event.preventDefault();
      event.stopPropagation();

      const events = [];
      let totalOriginalPrice = 0;
      let comboDiscount = 0;

      const checkboxes = form.querySelectorAll('input[type="checkbox"][name^="item"], input[type="radio"][name^="item"]');
      for (const checkbox of checkboxes) {
        if (checkbox.checked) {
          const originalPrice = Number.parseFloat(checkbox.getAttribute('data-price')) || 0;
          const line = checkbox.getAttribute('value');
          const tokens = line.split('^');
          if (tokens.length >= 5) {
            const [cartId, partNum, desc, price, quantity, shippingCost] = tokens;
            if (!desc.match(/discount +package|bonus +materials/i)) {
              events.push(line);
              totalOriginalPrice += originalPrice;
            }
          }
        }
      }

      if (events.length < 2) {
        swal({
          type: 'error',
          text: "Please select 2 or more events to take advantage of the combo discount.",
        });

        return;
      }

      if (events.length - 1 >= discountLevels.length) {
        comboDiscount = discountLevels[discountLevels.length - 1];
      } else {
        comboDiscount = discountLevels[events.length - 2];
      }

      const finalEventPrice = totalOriginalPrice - comboDiscount;
      const multRegValue = `a-2544^=TF==SF=WSCOMBO^${events.length}-Workshop Combo + ${events.length} Regular Price^${finalEventPrice}^1^0`;

      form.querySelector('#multreg').setAttribute('value', multRegValue);
      addToCart(form);
    } else if ($(form).find("#multreg").length) {
      // If there's a multi-reg form, just ignore it.
    } else {
      event.preventDefault();
      event.stopPropagation();
      addToCart(form);
    }
  }
}, true);
